/**
 * Generated bundle index. Do not edit.
 */

export * from './public-api';

export {HttpRequestInterceptor as ɵa} from './lib/interceptors/http-request.interceptor';